import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type { Complication, ComplicationFormPayload } from '../../types/complication'

export const complicationService = {
  async list(params?: {
    with_trashed?: boolean
    only_trashed?: boolean
    is_active?: boolean
    search?: string
    page?: number
    per_page?: number
  }) {
    const { data } = await apiClient.get<
      ApiPaginatedResponse<Complication> | ApiSuccessResponse<Complication[]>
    >('/complications', { params })
    return data
  },

  async create(payload: ComplicationFormPayload) {
    const { data } = await apiClient.post<ApiSuccessResponse<Complication>>('/complications', payload)
    return data
  },

  async update(id: string, payload: ComplicationFormPayload) {
    const { data } = await apiClient.put<ApiSuccessResponse<Complication>>(
      `/complications/${id}`,
      payload,
    )
    return data
  },

  async remove(id: string) {
    const { data } = await apiClient.delete<ApiSuccessResponse<null>>(`/complications/${id}`)
    return data
  },

  async restore(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<Complication>>(
      `/complications/${id}/restore`,
    )
    return data
  },
}
